import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import toast from 'react-hot-toast';
import { FaVideo, FaSpinner, FaTimes } from 'react-icons/fa';

const VideoUploader = ({ onChange, initialVideoUrl = null, label = "Video", uploader }) => {
  const [preview, setPreview] = useState(initialVideoUrl);
  const [isUploading, setIsUploading] = useState(false);

  const onDrop = useCallback(async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);
    setPreview(previewUrl);

    setIsUploading(true);
    try {
      const uploadedUrl = await uploader(file);
      if (uploadedUrl) {
        onChange(uploadedUrl);
        toast.success('Video subido con éxito.');
      }
    } catch (error) {
      console.error("Error en onDrop de VideoUploader:", error);
      setPreview(initialVideoUrl); // Revertir si falla
    } finally {
      setIsUploading(false);
    }
  }, [onChange, initialVideoUrl, uploader]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'video/mp4': ['.mp4'], 'video/quicktime': ['.mov'], 'video/webm': ['.webm'] },
    multiple: false,
  });

  const removeVideo = (e) => {
    e.stopPropagation();
    setPreview(null);
    onChange(null);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        {label}
      </label>
      <div
        {...getRootProps()}
        className={`relative w-full h-48 border-2 border-dashed rounded-lg flex items-center justify-center text-center cursor-pointer
                   transition-colors duration-200 ${isDragActive ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20' : 'border-gray-300 dark:border-gray-600 hover:border-blue-400'}`}
      >
        <input {...getInputProps()} />

        {isUploading ? (
          <div className="flex flex-col items-center text-gray-500">
            <FaSpinner className="animate-spin text-3xl" />
            <p className="mt-2">Subiendo video...</p>
          </div>
        ) : preview ? (
          <>
            <video src={preview} controls className="w-full h-full object-contain rounded-lg" />
            <button
              onClick={removeVideo}
              className="absolute top-2 right-2 bg-black bg-opacity-50 text-white rounded-full p-1.5 hover:bg-opacity-75"
              aria-label="Eliminar video"
            >
              <FaTimes />
            </button>
          </>
        ) : (
          <div className="flex flex-col items-center text-gray-500">
            <FaVideo className="text-3xl" />
            <p className="mt-2 text-sm">
              {isDragActive ? 'Suelta el video aquí' : 'Arrastra un video o haz clic para seleccionar'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoUploader;